<template>
  <div class="bridge-signing-view container fluid">
    <v-card>
      <BridgeSigningTable />
    </v-card>
  </div>
</template>

<script>
import BridgeSigningTable from '@/components/bridgeSigning/BridgeSigningTable';

export default {
  name: 'BridgeSigningView',
  components: {
    BridgeSigningTable,
  },
  data() {
    return {

    };
  },
};
</script>

<style lang="scss">
.bridge-signing-view {
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/views/bridgeSigning/BridgeSigningView.vue